import React from "react";

import AboutApi from "../../../Data/HomePage/AboutApi";

function AboutAreaSection() {
  return (
    <>
      <section className="about-area page-section scroll-to-page" id="about">
        <div className="custom-container">
          <div className="about-content content-width">
            <div className="section-header">
              <h4
                className="subtitle scroll-animation"
                data-animation="fade_from_bottom"
              >
                <i className="lar la-user"></i> About
              </h4>
              {/* <h1
                className="scroll-animation"
                data-animation="fade_from_bottom"
              >
                Every great design begin with
                <br />
                an even <span>better story</span>
              </h1> */}
            </div>
            <p className="scroll-animation" data-animation="fade_from_bottom">
              <h4 className="primary-color">
                {AboutApi.about.front_end_title}
              </h4>
              <p>{AboutApi.about.front_end_title_description}</p>
              <h4 className="primary-color"> {AboutApi.about.ios_title}</h4>
              <p> {AboutApi.about.ios_description}</p>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutAreaSection;
